import { Component, Listen, Prop, Watch } from '@stencil/core';

/**
 * Fixes Django-CMS issues with WebComponents.
 */

@Component({
  tag: 'hylo-django-cms-fix',
  styleUrl: 'hylo-django-cms-fix.scss'
})
export class HyloDjangoCmsFix {

  /** @internal */
  constructor() {

    this.refresh = this.refresh.bind(this);
  }


  /**
   * With this component the DjangoCMS toolbar will be mostly hidden and only appear on mouse over.
   * Set this property to keep the toolbar always visible.
   */
  @Prop() dontHideToolbar: boolean;

  /**
   * By default DjangoCMS is adding a top margin to the html element and this component is removing it again.
   * Set this property to keep the top margin.
   */
  @Prop() dontRemoveHtmlMargin: boolean;

  /**
   * Comma separated css queries which define which img tags come from the django cms richtext editor and should be altered.
   *
   * These img tags will be wrapped in a div tag with the class "django-cms-image" and
   * div tags will be added which contain the author and description of the image.
   * The div tags will get the classes "django-cms-image-author" and "django-cms-image-description" respectively.
   *
   * If the img tag contains a style "float: left" or "float: right", the style will be removed and
   * the wrapping div tag will get the class "django-cms-image-left" or "django-cms-image-right" respectively.
   *
   * If the img tag contains a "width" or "height" attribute, the img tag and the wrapper will get the class "has-dimensions".
   */
  @Prop() imgCssQueries: string;


  private cms: any;
  private head_html: string = '';
  private head_styles: NodeList;
  private breakpoint = null;


  /** @internal */
  @Watch('dontHideToolbar')
  onDontHideToolbar(value: boolean) {

    const html = document.querySelector('html');
    if (value) html.classList.add('dont-hide-django-cms-toolbar');
    else html.classList.remove('dont-hide-django-cms-toolbar');
  }


  /** @internal */
  @Listen('hyloNavDidChange', {target: 'window'})
  onHyloNavDidChange() {

    this.fixImg();
  }


  /** @internal */
  componentDidLoad() {

    this.backup();
    this.fixImg();
    this.fix();

    if (this.dontHideToolbar) document.querySelector('html').classList.add('dont-hide-django-cms-toolbar');

    window.setTimeout(() => {
      if (!this.cms) this.fix();
    }, 1000);
  }

  /** @internal */
  componentDidUpdate() {

    this.backup();
    this.fixImg();
    if (!this.cms) {

      this.fix();

      window.setTimeout(() => {
        if (!this.cms) this.fix();
      }, 1000);
    }
  }


  private backup() {

    const head = document.querySelector('head');
    this.head_html = head.innerHTML;
    this.head_styles = head.querySelectorAll('style');

    const init = window.setInterval(() => {
      var head_html = head.innerHTML;
      if (this.head_html == head_html) window.clearInterval(init);
      else {
        this.head_html = head_html;
        this.head_styles = head.querySelectorAll('style');
      }
    }, 1000);
  }

  private fix() {

    this.cms = window['CMS'];
    if (!this.cms) return;

    if (this.breakpoint) window.clearInterval(this.breakpoint);
    this.breakpoint = window.setInterval(() => {
      (document.querySelector('hylo-breakpoint-listener') as any)?.update();
    }, 1000);

    this.cms.$(window).off('cms-content-refresh');
    this.cms.$(window).on('cms-content-refresh', this.refresh);

    if (!this.dontRemoveHtmlMargin) {
      document.querySelector('html').style.marginTop = null;
    }
  }

  private fixImg() {

    if (!this.imgCssQueries) return;

    const queries = this.imgCssQueries.split(',');
    for (let i=0, l=queries.length; i<l; i++) {

      const query = queries[i].trim();
      const images = document.querySelectorAll(query);

      for (let o=0, p=images.length; o<p; o++) {

        const image = images[o] as HTMLImageElement;
        if (image.closest('.django-cms-image')) return;

        const wrapper = document.createElement('div');
        wrapper.classList.add('django-cms-image');

        if (image.style.float == 'left' || (image.getAttribute('align') && image.getAttribute('align').includes('left'))) {
          wrapper.classList.add('django-cms-image-left');
          image.style.float = 'none';
        } else if (image.style.float == 'right' || (image.getAttribute('align') && image.getAttribute('align').includes('right'))) {
          wrapper.classList.add('django-cms-image-right');
          image.style.float = 'none';
        } else if (image.getAttribute('align') && image.getAttribute('align').includes('middle')) {
          wrapper.classList.add('django-cms-image-center');
        }

        image.parentElement.insertBefore(wrapper, image);
        wrapper.appendChild(image);

        const author_text = image.getAttribute('data-fb-author');
        if (author_text) {
          const author = document.createElement('div');
          author.classList.add('django-cms-image-author');
          author.innerHTML = author_text;
          wrapper.appendChild(author);
        }

        const description_text = image.getAttribute('data-fb-description');
        if (description_text) {
          const description = document.createElement('div');
          description.classList.add('django-cms-image-description');
          description.innerHTML = description_text;
          wrapper.appendChild(description);
        }

        if (image.getAttribute('width') !== null) {
          wrapper.classList.add('has-dimensions');
          image.classList.add('has-dimensions');
        }
        if (image.getAttribute('height') !== null) {
          wrapper.classList.add('has-dimensions');
          image.classList.add('has-dimensions');
        }
      }
    }
  }

  private refresh() {

    const head = document.querySelector('head');
    const first = head.firstElementChild;

    for (var i=0, l=this.head_styles.length; i<l; i++) {
      head.insertBefore(this.head_styles[i], first);
    }
  }

}
